import { toast } from "sonner";
import { Trash2, PackageCheck } from "lucide-react";
import { api, API, errMsg, fmtDate } from "@/lib/api";
import { InclusionChips } from "@/pages/InclusionsPage";

const Shipment = ({ s, isAdmin, onDeleted }) => {
  const remove = async () => {
    if (!window.confirm("Undo this bundle? Its inclusions go back to the owed total.")) return;
    try {
      await api.delete(`/inclusion-shipments/${s.id}`);
      toast.success("Bundle removed");
      onDeleted();
    } catch (e) {
      toast.error(errMsg(e, "Couldn't remove bundle"));
    }
  };
  const photo = `${API}/inclusion-shipments/${s.id}/photo`;
  return (
    <div data-testid={`shipment-${s.id}`} className="flex gap-4 rounded-2xl border border-emerald-500/15 bg-zinc-900/60 p-4">
      {s.has_photo ? (
        <a href={photo} target="_blank" rel="noreferrer" className="shrink-0">
          <img data-testid={`shipment-photo-${s.id}`} src={photo} alt="Inclusion bundle" className="h-20 w-20 rounded-xl object-cover transition-transform duration-200 hover:scale-105" />
        </a>
      ) : (
        <div className="h-20 w-20 shrink-0 rounded-xl bg-zinc-950 grid place-items-center"><PackageCheck className="h-6 w-6 text-emerald-400/70" /></div>
      )}
      <div className="min-w-0 flex-1 space-y-1.5">
        <div className="text-xs font-mono text-zinc-500">Sent {fmtDate(s.created_at)}</div>
        <div className="text-sm font-medium">{s.drop_titles.join(" · ")}</div>
        <InclusionChips totals={s.totals} testPrefix={`shipment-total-${s.id}`} />
        {s.note && <p className="text-xs text-zinc-400">{s.note}</p>}
      </div>
      {isAdmin && (
        <button type="button" data-testid={`shipment-delete-${s.id}`} onClick={remove} className="self-start rounded-full p-2 text-zinc-500 hover:bg-red-500/10 hover:text-red-300 transition-colors" aria-label="Undo bundle">
          <Trash2 className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default function ShipmentList({ shipments, isAdmin, onChange }) {
  if (!shipments.length) return null;
  return (
    <div className="mt-8" data-testid="shipment-list">
      <h2 className="font-display text-base md:text-lg font-bold mb-3">Sent bundles</h2>
      <div className="space-y-2.5">
        {shipments.map((s) => <Shipment key={s.id} s={s} isAdmin={isAdmin} onDeleted={onChange} />)}
      </div>
    </div>
  );
}
